import { render, staticRenderFns } from "./OverviewGrid.vue?vue&type=template&id=6b5212ae"
import script from "./OverviewGrid.vue?vue&type=script&lang=js"
export * from "./OverviewGrid.vue?vue&type=script&lang=js"
import style0 from "./OverviewGrid.vue?vue&type=style&index=0&id=6b5212ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports